module.exports = __webpack_public_path__ + "img/wm-bus-repeater-sm.6f3cfa17.svg";